import { defineNuxtPlugin } from '#app';
import { NuxtLink } from '#components';

//VuetifyRender.js compiles NuxtLink to nuxtlink after which the link don't work, this plugin prevents that

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('NuxtLink', NuxtLink);
});